//@flow
import React, {useState, useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Grid, MenuItem} from '@material-ui/core';
import CustomSelect from '../../../../elements/CustomSelect/CustomSelect';

import {useFormContext} from 'react-hook-form';
import CustomTextField from '../../../../elements/CustomTextField/CustomTextField';
import {ON_BOARDING_FIELDS} from '../../utils/constants';
import {debounce} from '../../../../utils/functions';

const useStyles = makeStyles(theme => ({
  label: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#1E1E26',
  },
}));

const canalesOptions = [
  'Por recomendación de un conocido',
  'Por Google',
  'Por Instagram',
  'Por Facebook',
  'Por TikTok',
  'Por Youtube',
  'Porque compré a una marca que usa TiendaDa',
  'Otros',
];

export default function HowDoYouFindUs() {
  const classes = useStyles();
  const {register, errors, setValue, clearErrors} = useFormContext();

  const [channel, setChannel] = useState('');
  const [showOtherInput, setShowOtherInput] = useState(false);

  useEffect(() => {
    register(ON_BOARDING_FIELDS.REFERRAL_INFORMATION, {
      required: 'Este campo es requerido',
    });
  }, [register]);

  useEffect(() => {
    if (!channel) return;

    setValue(ON_BOARDING_FIELDS.REFERRAL_INFORMATION, channel);
  }, [channel, setValue]);

  const error = errors[ON_BOARDING_FIELDS.REFERRAL_INFORMATION];

  useEffect(() => {
    //NOTE: this because the error is not cleared when the user selects a value
    if (!error) return;
    if (!channel) return;
    clearErrors(ON_BOARDING_FIELDS.REFERRAL_INFORMATION);
  }, [channel, clearErrors, error]);

  const handleInputChange = debounce((value: string) => {
    setChannel(value);
  }, 500);

  return (
    <div className={classes.formWrapper}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <CustomSelect
            fullWidth
            defaultValue=""
            name="channel"
            style={{background: 'white'}}
            error={!!error}
            helperText={error ? error.message : ''}
            onChange={e => {
              setChannel(e.target.value);
              if (e.target.value === 'Otros') {
                setShowOtherInput(true);
              } else {
                setShowOtherInput(false);
              }
            }}
          >
            <MenuItem value="" hidden />
            {canalesOptions.map(c => (
              <MenuItem key={`currency-option-${c}`} value={c}>
                {c}
              </MenuItem>
            ))}
          </CustomSelect>
        </Grid>

        {showOtherInput && (
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <CustomTextField
              placeholder="Otros"
              autoFocus
              onChange={e => {
                handleInputChange(e.target.value);
              }}
            />
          </Grid>
        )}
      </Grid>
    </div>
  );
}
